import React from 'react';
import s from './GlobalLoader.module.scss';
import SvgIcon from '../icon/svgIcon/SvgIcon';
import { getCurrentThemeFromDom, getThemeAsset, normalizeTheme } from '@configs/themeAssets';
import { useCompanyTheme } from '@hooks/useCompanyTheme';

export const GlobalLoader: React.FC = () => {

  const company = useCompanyTheme()

const theme =
  getCurrentThemeFromDom() ??
  normalizeTheme(company) ??
  null;

const srcLogo = getThemeAsset(theme, 'icon-loader', 'icon-loader-rotate');

if (!srcLogo) return null;

return (

  <div className={s.loader}>
    <div className={s.circleWrap}>
      <SvgIcon name="icon-loader-dashed" className={s.dashed} />
      <SvgIcon name={srcLogo} className={s.rotating} />
    </div>
  </div>
)};
